import type { ReportParameterConfig } from '../CustomDash/components/PageConfigProvider/page-reducer';
import type { GlobalAssistantReportParamSuggestion } from './global-ai-assistant-api';

const parameterMatchesSuggestion = (
  parameter: ReportParameterConfig,
  suggestion: GlobalAssistantReportParamSuggestion,
  promotedParameterIds?: readonly string[]
): boolean => {
  if (parameter.parameterId === suggestion.parameterId) {
    return true;
  }
  if (promotedParameterIds?.includes(parameter.parameterId)) {
    return true;
  }
  return parameter.name === suggestion.displayName;
};

const matchReportParameterForSuggestion = (
  suggestion: GlobalAssistantReportParamSuggestion,
  parameters: ReportParameterConfig[],
  promotedParameterIds?: readonly string[]
): ReportParameterConfig | null =>
  parameters.find((parameter) =>
    parameterMatchesSuggestion(parameter, suggestion, promotedParameterIds)
  ) ?? null;

export const groupSuggestionsByReportParameter = (
  suggestions: GlobalAssistantReportParamSuggestion[],
  parameters: ReportParameterConfig[],
  parameterMappings?: Array<{
    parameterId: string;
    promotedParameterIds?: readonly string[];
  }>
): Map<ReportParameterConfig, GlobalAssistantReportParamSuggestion[]> => {
  const assignments = new Map<
    ReportParameterConfig,
    GlobalAssistantReportParamSuggestion[]
  >();

  suggestions.forEach((suggestion) => {
    const mapping = parameterMappings?.find(
      (entry) => entry.parameterId === suggestion.parameterId
    );
    const parameter = matchReportParameterForSuggestion(
      suggestion,
      parameters,
      mapping?.promotedParameterIds
    );
    if (!parameter) {
      return;
    }
    assignments.set(parameter, [
      ...(assignments.get(parameter) ?? []),
      suggestion,
    ]);
  });

  return assignments;
};

export const countResolvedSuggestions = (
  suggestions: GlobalAssistantReportParamSuggestion[]
): number =>
  suggestions.filter((suggestion) => suggestion.resolutionStatus === 'resolved')
    .length;
